// extracted by mini-css-extract-plugin
export default {"secondaryNav":"styles_secondaryNav__F1Cwc"};